// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoRouterOutlinedSvg from "@fishx/icons-svg/es/asn/PtoRouterOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoRouterOutlined = function PtoRouterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoRouterOutlinedSvg
  }));
};

PtoRouterOutlined.displayName = 'PtoRouterOutlined';
export default React.forwardRef(PtoRouterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoRouterOutlined.js
// module id = 3926
// module chunks = 0